import { setCrmLeadDeepLinkPendingLeadId } from '@pages/Admin/CRM/hooks/crmLeadDeepLinkPending'

const HTTP_URL_RE = /(https?:\/\/[^\s]+)/

export const extractFirstHttpUrl = (text?: string | null): string | null => {
  if (!text) return null
  const match = String(text).match(HTTP_URL_RE)
  return match?.[0] ?? null
}

export const buildCrmIntegrationMessagePath = (notification: {
  lead_id?: number | string | null
  message?: string | null
}): string | null => {
  const urlFromMessage = extractFirstHttpUrl(notification?.message)
  if (urlFromMessage) {
    try {
      const parsed = new URL(urlFromMessage)
      if (parsed.hostname === window.location.hostname) {
        return `${parsed.pathname}${parsed.search}${parsed.hash}`
      }
      return urlFromMessage
    } catch {
      // fall through to lead_id
    }
  }

  const leadId = Number(notification?.lead_id)
  if (!Number.isFinite(leadId) || leadId <= 0) return null

  return `/crm?lead-id=${Math.trunc(leadId)}`
}

type HistoryLike = {
  push: (path: string) => void
}

/** Переход к лиду из platform-уведомления crm_integration_message. */
export const openCrmIntegrationMessageNotification = (
  notification: {
    lead_id?: number | string | null
    message?: string | null
  },
  history: HistoryLike,
) => {
  const path = buildCrmIntegrationMessagePath(notification)
  if (!path) return

  const leadId = Number(notification?.lead_id)
  if (Number.isFinite(leadId) && leadId > 0) {
    setCrmLeadDeepLinkPendingLeadId(Math.trunc(leadId))
  } else if (path.startsWith('/')) {
    try {
      const parsed = new URL(path, window.location.origin)
      const fromQuery = Number(parsed.searchParams.get('lead-id'))
      if (Number.isFinite(fromQuery) && fromQuery > 0) {
        setCrmLeadDeepLinkPendingLeadId(Math.trunc(fromQuery))
      }
    } catch {
      // ignore
    }
  }

  if (/^https?:\/\//i.test(path)) {
    window.location.assign(path)
    return
  }

  history.push(path)
}

const PROVIDER_LABELS: Record<string, string> = {
  telegram: 'Telegram',
  vkontakte: 'VK',
  max: 'MAX',
  wazzup: 'Wazzup',
}

export const getCrmIntegrationMessageProviderLabel = (
  provider?: string | null,
): string | null => {
  if (!provider) return null
  return PROVIDER_LABELS[provider] ?? provider
}
